<template>
    <div>
        <h3 class="alert alert-dark mt-3">Avaliação</h3>

        <template v-if="value">
            <div class="form-row">
                <div class="col col-12 col-md-3">
                    <slot></slot>
                </div>

                <div class="col col-12 col-md-3">
                    <az-input
                        label="Fator"
                        type="number"
                        :compact="true"
                        sizing="sm"
                        placeholder="Fator de Divisão do Resultado..."
                        :validate="validate"
                        v-model="value.fs">
                    </az-input>
                </div>

                <div class="col col-12 col-md-6">
                    <az-input
                        label="Fórmula"
                        :compact="true"
                        sizing="sm"
                        placeholder="Fórmula de Cálculo... (Padrão Soma / Fator)..."
                        :validate="validate"
                        v-model="value.fc">
                    </az-input>
                </div>
            </div>

            <div class="form-row" v-for="(avaliacao, iax) in value.js_avaliacao" :key="iax">
                <div class="col col-12 col-md-4">
                    <az-input
                        sizing="sm"
                        placeholder="Resultado..."
                        required
                        :validate="validate"
                        v-model="avaliacao.resultado">
                        <template v-slot:button-pre>
                            <div class="input-group-prepend">
                                <button class="btn btn-outline-danger" type="button" @click="remover_avaliacao(iax)">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-2">
                    <az-input
                        sizing="sm"
                        placeholder="Cor..."
                        type="select"
                        :optionsList="[
                            { id: 'primary', search: 'Azul' },
                            { id: 'success', search: 'Verde' },
                            { id: 'danger', search: 'Vermelho' },
                            { id: 'dark', search: 'Preto' },
                            { id: 'secondary', search: 'Cinza' },
                            { id: 'warning', search: 'Amarelo' },
                            { id: 'info', search: 'Ciano' },
                        ]"
                        optionsData="id"
                        :validate="validate"
                        v-model="avaliacao.cor">
                    </az-input>
                </div>
                <div class="col col-12 col-md-3">
                    <az-input   
                        type="number"
                        placeholder="De..."
                        sizing="sm"
                        icon="fa-solid fa-greater-than-equal"
                        v-model="avaliacao.de" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input   
                        type="number"
                        placeholder="Até..."
                        sizing="sm"
                        icon="fa-solid fa-less-than-equal"
                        v-model="avaliacao.ate" />
                </div>
            </div>
        </template>

        <button type="button" class="btn btn-outline-primary btn-sm" @click="incluir_avaliacao()">
            <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 

        };
    },

    components: { 
        AzInput, 
    },

    props: ['value', 'validate'],

    methods: { 
        incluir_avaliacao() {
            if ( !this.value ) { 
                this.value = { js_avaliacao: [] };
                this.$emit('input', this.value);
            }

            this.value.js_avaliacao.push({
                resultado: null,
                cor: null,
                de: null,
                ate: null,
            });
        },

        remover_avaliacao(iax) {
            this.value.js_avaliacao.splice(iax, 1);
        },
    },
}
</script>
